export default class SavedAddress {
  public address1!: string;
  public address2!: string;
  public address3!: string;
  public addressId!: number;
  public avsCheckedTimes!: number;
  public city!: string;
  public companyName?: string;
  public country?: {
    active?: boolean;
    code?: string;
    id?: string;
    label?: string;
    name?: string;
  } | null;

  public displayName?: string;
  public firstName!: string;
  public lastName!: string;
  public latitude!: string;
  public isPrimary?: boolean;
  public longitude!: string;
  public passedAVS!: true;
  public phone!: string;
  public postalCode!: string;
  public postalCodeExt!: string;
  public state?: string;
  public type!: number;
  public userId!: string;

  public constructor(init?: Partial<SavedAddress>) {
    Object.assign(this, init);

    this.country = {
      code: "US",
      name: "United States",
      active: true,
    };
  }
}
